module.exports = __webpack_public_path__ + "media/images/front/medical_leaders/top/icon_arrow_navy-6db42850b7a5ea7ed72acf3bb7348e0c.svg";